import { MapObject } from "../../../types/tower-defense";
import { GameVars } from "../../GameVars";

export class WavesList extends Phaser.GameObjects.Container {

    private mapData: MapObject;
    private inputsText: any[];
    private upBtns: Phaser.GameObjects.Graphics[];
    private downBtns: Phaser.GameObjects.Graphics[];

    constructor(scene: Phaser.Scene, mapData: MapObject) {

        super(scene);

        this.x = 10;
        this.y = 370;

        this.mapData = mapData;

        this.inputsText = [];
        this.upBtns = [];
        this.downBtns = [];

        let paths = this.mapData.paths.length;

        const bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.lineStyle(5, 0x000000);
        bck.strokeRect(0, 0, 965, paths * 10 * 22 + 10 * 4 + 5);
        this.add(bck);

        if (!GameVars.wavesInfo[this.mapData.name]) {
            GameVars.wavesInfo[this.mapData.name] = {};
        }

        let offY = 15;

        for (let i = 0; i < 10; i++) {

            let waveText = this.scene.add.text(8, offY,  "W" + (i + 1) + ":", {fontFamily: "Rubik-Regular", fontSize: "15px", color: "#000000", align: "center"});
            waveText.setOrigin(0, .5);
            this.add(waveText);

            for (let j = 0; j < paths; j++) {

                let element = this.scene.add.dom(470, offY).createFromCache("input-text");
                this.add(element);

                let inputText: any = element.getChildByName("fname");
                
                if (GameVars.wavesInfo[this.mapData.name].waves && GameVars.wavesInfo[this.mapData.name].waves["wave_" + (i + 1)] && GameVars.wavesInfo[this.mapData.name].waves["wave_" + (i + 1)].strings) {
                    inputText.value = GameVars.wavesInfo[this.mapData.name].waves["wave_" + (i + 1)].strings[j];
                }

                this.inputsText.push(inputText);

                offY += 22;
            }

            let downBtn = new Phaser.GameObjects.Graphics(this.scene);
            downBtn.setPosition(910, offY - 20 - (paths / 2) * 22);
            downBtn.fillStyle(0x000000);
            downBtn.fillTriangle(0, 0, 18, 0, 9, 18);
            downBtn.setInteractive(new Phaser.Geom.Rectangle(0, 0, 18, 18), Phaser.Geom.Rectangle.Contains);
            downBtn.on("pointerdown", () => {

                for (let j = 0; j < paths; j++) {
                    let auxStr = this.inputsText[(i * paths + j)].value;
                    this.inputsText[i * paths + j].value = this.inputsText[(i + 1) * paths + j].value;
                    this.inputsText[(i + 1) * paths + j].value = auxStr;
                }
            }, this);
            this.add(downBtn);

            this.downBtns.push(downBtn);

            if (i === 9) {
                downBtn.visible = false;
            }

            let upBtn = new Phaser.GameObjects.Graphics(this.scene);
            upBtn.setPosition(930, offY - 20 - (paths / 2) * 22);
            upBtn.fillStyle(0x000000);
            upBtn.fillTriangle(0, 18, 18, 18, 9, 0);
            upBtn.setInteractive(new Phaser.Geom.Rectangle(0, 0, 18, 18), Phaser.Geom.Rectangle.Contains);
            upBtn.on("pointerdown", () => {
                for (let j = 0; j < paths; j++) {
                    let auxStr = this.inputsText[(i * paths + j)].value;
                    this.inputsText[i * paths + j].value = this.inputsText[(i - 1) * paths + j].value;
                    this.inputsText[(i - 1) * paths + j].value = auxStr;
                }
            }, this);
            this.add(upBtn);

            this.upBtns.push(upBtn);

            if (i === 0) {
                upBtn.visible = false;
            }

            offY += 4;
        }
    }

    public getWavesStrings(): any {

        let wavesStrings = [];

        for (let i = 0; i < this.inputsText.length; i++) {
            wavesStrings.push(this.inputsText[i].value);
        }

        return wavesStrings;

    }
}
